import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

interface Vehicle {
  id: string;
  name: string;
  category: string;
  image: string;
}

const vehicles: Vehicle[] = [
  {
    id: '250LANDCRUISER',
    name: '250ランドクルーザープラド',
    category: 'SUV / OFF-ROAD',
    image: 'https://public.readdy.ai/ai/img_res/24051ff3467fb83bae7919ebef782d12.jpg'
  },
  {
    id: 'JIMNY_nomade',
    name: 'ジムニーノマド',
    category: '軽自動車 / OFF-ROAD',
    image: 'https://readdy.ai/api/search-image?query=Suzuki%20Jimny%20Nomad%20compact%20off-road%20vehicle%20in%20white%20with%20rugged%20custom%20wheels%20and%20lifted%20suspension%2C%20professional%20studio%20photography%20with%20clean%20light%20gray%20gradient%20background%2C%20front%20three-quarter%20view%20highlighting%20wheel%20fitment%20and%20off-road%20stance%2C%20minimalist%20backdrop%2C%20sharp%20product%20photography%20with%20soft%20lighting%2C%20adventure-ready%20styling%20showcase&width=280&height=200&seq=jimnyv2&orientation=landscape'
  },
  {
    id: 'ALPHARD40',
    name: '40系アルファード',
    category: 'ミニバン / LUXURY',
    image: 'https://readdy.ai/api/search-image?query=Toyota%20Alphard%2040%20series%20white%20luxury%20minivan%20with%20elegant%20custom%20alloy%20wheels%2C%20professional%20automotive%20studio%20photography%20with%20soft%20gradient%20background%20in%20pearl%20white%20tones%2C%20front%20three-quarter%20angle%20showcasing%20premium%20wheel%20design%2C%20clean%20minimalist%20backdrop%2C%20high-end%20product%20photography%20style%20with%20refined%20lighting%2C%20luxury%20vehicle%20presentation&width=280&height=200&seq=alph40v2&orientation=landscape'
  },
  {
    id: 'VOXY90',
    name: '90系ヴォクシー',
    category: 'ミニバン / FAMILY',
    image: 'https://readdy.ai/api/search-image?query=Toyota%20Voxy%2090%20series%20white%20minivan%20with%20sporty%20custom%20alloy%20wheels%2C%20professional%20automotive%20studio%20photography%20with%20clean%20light%20gray%20gradient%20background%2C%20front%20three-quarter%20view%20highlighting%20wheel%20design%20and%20aerodynamic%20styling%2C%20minimalist%20backdrop%2C%20sharp%20product%20photography%20with%20modern%20lighting%2C%20family%20vehicle%20showcase&width=280&height=200&seq=voxy90v2&orientation=landscape'
  },
  {
    id: 'ATRAI',
    name: 'アトレー',
    category: '軽自動車 / COMMERCIAL',
    image: 'https://readdy.ai/api/search-image?query=Daihatsu%20Atrai%20white%20compact%20commercial%20van%20with%20custom%20alloy%20wheels%2C%20professional%20automotive%20studio%20photography%20with%20soft%20gradient%20background%20in%20light%20silver%20tones%2C%20front%20three-quarter%20angle%20showcasing%20wheel%20fitment%2C%20clean%20minimalist%20backdrop%2C%20sharp%20product%20photography%20style%20with%20subtle%20shadows%2C%20versatile%20vehicle%20presentation&width=280&height=200&seq=atraiv2&orientation=landscape'
  },
  {
    id: 'HIJET',
    name: 'ハイゼット',
    category: '軽自動車 / COMMERCIAL',
    image: 'https://readdy.ai/api/search-image?query=Daihatsu%20Hijet%20white%20compact%20commercial%20truck%20with%20custom%20alloy%20wheels%2C%20professional%20automotive%20studio%20photography%20with%20clean%20light%20gray%20gradient%20background%2C%20front%20three-quarter%20view%20highlighting%20wheel%20design%2C%20minimalist%20backdrop%2C%20sharp%20product%20photography%20with%20modern%20lighting%2C%20work%20vehicle%20showcase&width=280&height=200&seq=hijetv2&orientation=landscape'
  },
  {
    id: 'HIACE200',
    name: '200系ハイエース',
    category: 'バン / COMMERCIAL',
    image: 'https://readdy.ai/api/search-image?query=Toyota%20Hiace%20200%20series%20white%20commercial%20van%20with%20premium%20custom%20alloy%20wheels%20and%20low%20profile%20tires%2C%20professional%20automotive%20studio%20photography%20with%20soft%20gradient%20background%20in%20pearl%20white%20tones%2C%20front%20three-quarter%20angle%20showcasing%20wheel%20design%20and%20vehicle%20stance%2C%20clean%20minimalist%20backdrop%2C%20high-end%20product%20photography%20style%20with%20refined%20lighting&width=280&height=200&seq=hiace200v2&orientation=landscape'
  },
  {
    id: 'DELICAD5',
    name: 'デリカD:5',
    category: 'ミニバン / ALL-TERRAIN',
    image: 'https://readdy.ai/api/search-image?query=Mitsubishi%20Delica%20D5%20white%20all-terrain%20minivan%20with%20rugged%20custom%20alloy%20wheels%2C%20professional%20automotive%20studio%20photography%20with%20clean%20light%20gray%20gradient%20background%2C%20front%20three-quarter%20view%20highlighting%20wheel%20design%20and%20off-road%20capability%2C%20minimalist%20backdrop%2C%20sharp%20product%20photography%20with%20dynamic%20lighting%2C%20adventure%20vehicle%20showcase&width=280&height=200&seq=delicad5v2&orientation=landscape'
  },
  {
    id: 'NBOX',
    name: 'N-BOX',
    category: '軽自動車 / COMPACT',
    image: 'https://readdy.ai/api/search-image?query=Honda%20N-BOX%20white%20compact%20kei%20car%20with%20stylish%20custom%20alloy%20wheels%2C%20professional%20automotive%20studio%20photography%20with%20soft%20gradient%20background%20in%20light%20silver%20tones%2C%20front%20three-quarter%20angle%20showcasing%20wheel%20fitment%20and%20modern%20design%2C%20clean%20minimalist%20backdrop%2C%20sharp%20product%20photography%20style%20with%20soft%20lighting%2C%20urban%20vehicle%20presentation&width=280&height=200&seq=nboxv2&orientation=landscape'
  }
];

interface VehicleGalleryProps {
  onVehicleSelect: (vehicleId: string) => void;
}

export default function VehicleGallery({ onVehicleSelect }: VehicleGalleryProps) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  const handleVehicleClick = (vehicleId: string) => {
    onVehicleSelect(vehicleId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section ref={ref} className="py-16 px-5 bg-[#0f0f0f]">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
      >
        <div className="flex items-start justify-between mb-8">
          <div>
            <p className="text-[#00d4ff] text-xs tracking-[0.2em] uppercase mb-2">
              VEHICLE LINEUP
            </p>
            <h2 className="text-white text-3xl font-black">選べる車両</h2>
          </div>
          <a href="#" className="text-[#00d4ff] text-sm flex items-center gap-2 mt-8 cursor-pointer whitespace-nowrap">
            すべて見る
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollbarWidth: 'none' }}>
          {vehicles.map((vehicle, index) => (
            <motion.div
              key={vehicle.id}
              initial={{ opacity: 0, x: 50 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className="flex-shrink-0 w-[280px] bg-[#1a1a1a] rounded-3xl overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.4)] hover:border hover:border-[#00d4ff] transition-all cursor-pointer"
            >
              <div className="w-full h-[200px] bg-gradient-to-br from-[#2a2a2a] to-[#1a1a1a] overflow-hidden">
                <img
                  src={vehicle.image}
                  alt={vehicle.name}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <h3 className="text-white text-lg font-medium mb-1">{vehicle.name}</h3>
                <p className="text-[#888888] text-xs mb-4">{vehicle.category}</p>
                <button
                  onClick={() => handleVehicleClick(vehicle.id)}
                  className="w-full py-3 bg-[#00d4ff] text-black font-bold rounded-xl hover:bg-[#00b8e6] transition-all active:scale-95 cursor-pointer whitespace-nowrap"
                >
                  シミュレート
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}